import React from "react";
import "./Lifting_Buildings.css";
import { Link } from "react-router-dom";
import ContactSection2 from "./ContactSection2";
import Adsense from "../Adsense";
import InArticleAd from "../InArticleAd";

export default function Lifting_Buildings() {
  return (
    <div className="Lifting_Buildings-page">

      {/* =====================================================
          HERO
      ===================================================== */}

      <div className="Lifting_Buildings-hero">
        <div className="Lifting_Buildings-overlay">
          <h1>הרמת מבנים</h1>
        </div>
      </div>


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <div className="page3">

        <div className="container">

          {/* =====================================================
              VIDEO - ראשון
          ===================================================== */}

          <div className="building-video-box">

            <div className="building-video-title">
              הרמת מבנים עם נצר הובלות ומנופים
            </div>

            <div className="building-video-wrapper">

              <video
                className="building-video"
                controls
                controlsList="nodownload"
                disablePictureInPicture
                playsInline
                preload="metadata"
                onContextMenu={(e) => e.preventDefault()}
              >
                <source
                  src="/video/17.mp4"
                  type="video/mp4"
                />

                הדפדפן שלך אינו תומך בניגון וידאו.
              </video>

            </div>

            <p className="building-video-caption">
              צפו בסרטון והכירו את עבודות הרמת המבנים
            </p>

          </div>


          {/* =====================================================
              TOP TEXT
          ===================================================== */}

          <h2 className="top-text">
            הרמת מבנים היא עבודה מורכבת הדורשת תכנון מקצועי,
            ציוד מתאים וניסיון. נצר הובלות ומנופים מספקת
            פתרונות הרמה למבנים במגוון גדלים ובתנאי שטח שונים.
          </h2>


          {/* =====================================================
              IMAGE + TEXT
          ===================================================== */}

          <div className="content-row">

            <div className="image-box">
              <img
                src="/images/30.jpeg"
                alt="הרמת מבנים"
              />
            </div>

            <div className="text-box">

              <p>
                הרמת מבנה דורשת בדיקה מקדימה של תנאי השטח,
                משקל המבנה, נקודות ההרמה ואפשרויות הגישה
                לציוד. לפני תחילת העבודה יש לתכנן את שלבי
                ההרמה וההצבה ולבחור את אמצעי ההרמה המתאים.
              </p>

              <p>
                עבודות הרמה יכולות להתבצע עבור מבנים ניידים,
                יחידות מגורים, משרדים, מבנים תעשייתיים ומבנים
                מיוחדים. תכנון נכון מאפשר לבצע את העבודה בצורה
                מסודרת ויעילה בהתאם לתנאים הקיימים במקום.
              </p>

            </div>

          </div>


          {/* =====================================================
              SECTION 1
          ===================================================== */}

          <h2 className="main-title">
            הרמת מבנים – תכנון נכון לפני תחילת העבודה
          </h2>

          <div className="bottom-text">

            <p>
              כל עבודת הרמת מבנה מתחילה בבדיקת המקום שבו
              מתבצעת העבודה. יש לבחון את נקודת ההרמה,
              נקודת ההצבה, הגישה למשאית ולמנוף ואת תנאי
              השטח מסביב למבנה.
            </p>

            <p>
              בנוסף יש לבדוק את משקל המבנה, מידותיו ומבנה
              נקודות האחיזה. הנתונים הללו מסייעים להתאים
              את אמצעי ההרמה ולתכנן את העבודה בצורה מסודרת.
            </p>


            {/* =====================================================
                SECTION 2
            ===================================================== */}

            <h2 className="main-title">
              הרמת מבנים בעזרת מנוף
            </h2>

            <p>
              מנוף מאפשר להרים מבנים במקרים שבהם לא ניתן
              להזיז אותם באמצעות אמצעים רגילים. בהתאם לסוג
              המבנה ולתנאי האתר ניתן לתכנן את אופן ההרמה
              וההעברה אל נקודת היעד.
            </p>

            <p>
              חשוב לבצע את העבודה תוך התאמת הציוד למבנה
              ולתנאי השטח וביצוע הפעולות בהתאם לתכנון
              המקדים של העבודה.
            </p>


            {/* =====================================================
                SECTION 3
            ===================================================== */}

            <h2 className="main-title">
              הרמת מבנים במקומות עם גישה מורכבת
            </h2>

            <p>
              בחלק מהמקרים המבנה נמצא באזור צפוף, ברחוב צר,
              בחצר או באתר שבו קיימות מגבלות גישה. במצבים
              כאלה חשוב לבצע בדיקה מקדימה ולבחון כיצד ניתן
              להציב את ציוד ההרמה במקום המתאים.
            </p>

            <p>
              תכנון מוקדם מאפשר לזהות מכשולים ולבחור פתרון
              שמתאים למבנה ולסביבה שבה מתבצעת העבודה.
            </p>


            {/* =====================================================
                SECTION 4
            ===================================================== */}

            <h2 className="main-title">
              הרמת מבנים והצבתם במקום חדש
            </h2>

            <p>
              לעיתים יש צורך לא רק להרים את המבנה אלא גם
              להעביר אותו אל נקודה חדשה ולהציב אותו בצורה
              מדויקת. במקרה כזה יש לתכנן מראש את מסלול
              ההעברה ואת נקודת ההצבה.
            </p>

            <p>
              נצר הובלות ומנופים מספקת פתרונות הכוללים
              הרמה, העברה והצבה של מבנים בהתאם לצורכי הלקוח
              ולתנאים בשטח.
            </p>


            {/* =====================================================
                SECTION 5
            ===================================================== */}

            <h2 className="main-title">
              הרמת מבנים ניידים ומבנים מיוחדים
            </h2>

            <p>
              מבנים ניידים, יחידות משרד, מבנים תעשייתיים
              ומבנים מיוחדים יכולים לדרוש פתרון הרמה בהתאם
              למידות, למשקל ולמבנה שלהם.
            </p>

            <p>
              בכל עבודה יש להתאים את שיטת ההרמה לתנאי המבנה
              ולתנאי השטח ולתכנן את התהליך מראש.
            </p>


            {/* =====================================================
                SECTION 6
            ===================================================== */}

            <h2 className="main-title">
              למה חשוב לבחור חברה מקצועית להרמת מבנים?
            </h2>

            <p>
              הרמת מבנה דורשת ניסיון, תכנון נכון והתאמת ציוד
              לעבודה. בדיקה מוקדמת של תנאי השטח יכולה לסייע
              לזהות את האתגרים ולתכנן את העבודה בצורה מסודרת.
            </p>

            <p>
              נצר הובלות ומנופים מתאימה את פתרון ההרמה
              וההובלה לסוג המבנה, לתנאי השטח ולדרישות
              הפרויקט.
            </p>


            {/* =====================================================
                SECTION 7
            ===================================================== */}

            <h2 className="main-title">
              נצר הובלות ומנופים – הרמת מבנים בפריסה ארצית
            </h2>

            <p>
              נצר הובלות ומנופים בע"מ מספקת שירותי הרמה,
              הובלה ומנוף למגוון רחב של מבנים וציוד.
              השירות ניתן בהתאם לצורכי הפרויקט ולתנאי השטח.
            </p>

            <p>
              צריכים הרמת מבנה? צרו איתנו קשר, ספרו לנו
              על העבודה ונבחן עבורכם את פתרון ההרמה וההובלה
              המתאים.
            </p>

          </div>


          {/* =====================================================
              CONTACT
          ===================================================== */}

          <ContactSection2 />


          {/* =====================================================
              LINKS
          ===================================================== */}

          <div className="links">

            <Link
              to="/Relocation_of_buildings"
              className="link-right"
            >
              העברת מבנים
            </Link>

            <Link
              to="/BuildingRehabilitation"
              className="link-left"
            >
              הובלת קרוואנים
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}